/**
 * Polling-day time in India (UTC+5:30, no daylight saving), whatever time zone the phone is set to.
 */
import { TURNOUT_SLOTS, type TurnoutSlot } from "@npac/rules";

const IST_OFFSET_MIN = 330;

export function istParts(now: number): { date: string; minutes: number; hhmm: string } {
  const d = new Date(now + IST_OFFSET_MIN * 60_000);
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, "0");
  const day = String(d.getUTCDate()).padStart(2, "0");
  const hh = d.getUTCHours();
  const mm = d.getUTCMinutes();
  return { date: `${y}-${m}-${day}`, minutes: hh * 60 + mm, hhmm: `${String(hh).padStart(2, "0")}:${String(mm).padStart(2, "0")}` };
}

/** "13" → 13:00 → 780 minutes after midnight */
export const slotMinutes = (s: TurnoutSlot) => Number(s) * 60;

/** Lead time: from 20 minutes before a slot, that slot is the one being reported. */
export const SLOT_LEAD_MIN = 20;

/**
 * The slot a worker is most likely reporting now (IST): the latest slot that has started, counting
 * from 20 minutes before it. Before 08:40 → 09, after 16:40 → 17.
 *   10:15 → 09 (the 9 o'clock figure, reported late)   10:45 → 11   13:05 → 13
 */
export function currentSlot(now: number): TurnoutSlot {
  const { minutes } = istParts(now);
  let pick: TurnoutSlot = TURNOUT_SLOTS[0];
  for (const s of TURNOUT_SLOTS) if (minutes >= slotMinutes(s) - SLOT_LEAD_MIN) pick = s;
  return pick;
}

/** "13" → "1 बजे" / "1 pm" */
export function slotLabel(s: TurnoutSlot, lang: "hi" | "en"): string {
  const h = Number(s);
  const h12 = h > 12 ? h - 12 : h;
  return lang === "hi" ? `${h12} बजे` : `${h12} ${h >= 12 ? "pm" : "am"}`;
}
